export enum Cookie {
    LOCALE = 'language-selection',
    CONTEXT_MODIFY = 'context-modify',
    VIEWPORT = 'viewport',
}
